import React, { Component } from "react";
import { Row, Collapse, Button, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class FilterSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: !(props.open || true),
      clearFilters: props.clearFilters
    };
    this.toggleFilter = this.toggleFilter.bind(this);
    this.getFilterDisplay = this.getFilterDisplay.bind(this);
  }

  toggleFilter() {
    const collapse = !this.state.collapse;
    this.setState({
      collapse: collapse
    });
    if (this.props.action) this.props.action();
  }

  getFilterDisplay(filters) {
    if (!filters || !filters.length || filters.length === 0) {
      return null;
    }
    const filterDisplay = filters
      .map(x =>
        x.value || x.startDate || x.endDate
          ? x.filteredDisplay
          : null
      )
      .join(" | ");

    if (!filterDisplay) {
      return "";
    }

    return ` - ${filterDisplay}`;
  }

  render() {
    return (
      <div className="mb-1">
        <Row>
          <Col>
            {this.props.customFilterClassName && (
              <span className="">Filters</span>
            )}
            <span
              title="Click here to toggle filter display"
              className={
                this.props.customFilterClassName
                  ? this.props.customFilterClassName
                  : "filter-toggle"
              }
              onClick={() => this.toggleFilter()}
            >
              <FontAwesomeIcon icon="filter" /> Filters
                        </span>
            <span className="filterDisplay">
              {this.getFilterDisplay(this.props.filters)}
            </span>
            {this.props.filters && this.props.filters.length !== 0 && (
              <Button
                className="cbdmdDanger ml-4 xs"
                size="sm"
                style={{ marginTop: "-6px", marginBottom: "4px" }}
                onClick={this.state.clearFilters}
              >
                <FontAwesomeIcon
                  icon="backspace"
                  className="mr-2 ml-0 mt-0 mb-0"
                />{" "}
                                Clear
              </Button>
            )}
          </Col>
        </Row>
        <Collapse isOpen={this.state.collapse}>
          <Row>
            {this.props.children}
          </Row>
        </Collapse>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterSet.js